import $ from 'jquery';
import '../plugins/scrolloverflow';
import fullpage from 'fullpage.js';

class FullpageScroller {
	constructor(els) {
        // temp fix for Unable to preventDefault inside passive event listener due to target being treated as passive.
        window.addEventListener('wheel', event => { event.preventDefault(); }, { passive: false });

		this.container = $(els);

		if($(window).width() < 768) {
			$('#fullpage').removeAttr('id');
		} else {
			this.createScroller();
		}
	}

	createScroller() {
		const that = this;

		this.container.fullpage({
			navigation: true,
			navigationPosition: 'right',
            css3: true,
            scrollBar: true,
            hybrid: true,
            scrollOverflow: true,
            controlArrows: true,
            verticalCentered: true,
            fitToSection: true
		});

		// this.events();
	}

	events() {
		const that = this;

		if ($(window).width() < 768) {
			that.setScrolling(false);
		} else {
			that.setScrolling(true);
		}

        $(window).on('resize', function() {
            if ($(window).width() < 768) {
                that.setScrolling(false);
            } else {
                that.setScrolling(true);
            }
        });
	}

	setScrolling(boolean) {
		this.container.fullpage.setAllowScrolling(boolean);
	}
}

export default {
	new(els) {
		this.fullpage = new FullpageScroller(els);
	},
	setScrolling(boolean) {
		if ($('#home').length) {
			this.fullpage.setScrolling(boolean);			
		}
	}
}



// WEBPACK FOOTER //
// ./src/js/modules/fullpageScroller.js